export var StudyState;
(function (StudyState) {
    StudyState["Open"] = "open";
    StudyState["Closed"] = "closed";
    StudyState["Draft"] = "draft";
    StudyState["Archived"] = "archived";
    StudyState["Deleted"] = "deleted";
    StudyState["Hidden"] = "hidden";
})(StudyState || (StudyState = {}));
export var StudyType;
(function (StudyType) {
    StudyType["Full"] = "full";
    StudyType["LiveOnly"] = "live_only";
})(StudyType || (StudyType = {}));
export var StudyGroup;
(function (StudyGroup) {
    StudyGroup["Current"] = "current";
    StudyGroup["Deleted"] = "deleted";
})(StudyGroup || (StudyGroup = {}));
